import { render, staticRenderFns } from "./ViewerCurrentDetailContent.vue?vue&type=template&id=253fb623"
import script from "./ViewerCurrentDetailContent.vue?vue&type=script&lang=js"
export * from "./ViewerCurrentDetailContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports